import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  viewChild
} from '@angular/core';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent
} from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

import { NavbarComponent } from '@app/layout/containers/navbar/navbar.component';
import { SidenavComponent } from '@app/layout/containers/sidenav/sidenav.component';
import { APP_STORE } from '@core/stores/app.store';
import { USER_STORE } from '@core/stores/user.store';
import { SeoService } from '@shared/services/seo.service';
import { ENVIRONMENT } from '@env/environment';
import { FileDownloadNotificationComponent } from '@file-upload/containers/file-download-notification/file-download-notification.component';
import { NotificationsSidenavComponent } from '@notifications/containers/notifications-sidenav/notifications-sidenav.component';
import { NOTIFICATIONS_STORE } from '@notifications/stores/notifications.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    RouterOutlet,

    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,

    NavbarComponent,
    SidenavComponent,

    FileDownloadNotificationComponent,
    NotificationsSidenavComponent
  ]
})
export class AppComponent {
  readonly matSidenavContent =
    viewChild<MatSidenavContent>('matSidenavContent');

  readonly #seoService = inject(SeoService);
  readonly #appStore = inject(APP_STORE);
  readonly #notificationsStore = inject(NOTIFICATIONS_STORE);
  readonly #userStore = inject(USER_STORE);

  isNotificationsSidenavOpened = this.#notificationsStore.isSidenavOpened;
  user = this.#userStore.data;
  sidenavPinned = this.#appStore.sidenavPinned;
  isDataSaving = this.#appStore.isDataSaving;

  constructor() {
    // this is needed because there is no navigation for the first navigation
    this.#seoService.updateTitle('Client Setup');
    this.redirectForTermsAndConditions();
  }

  redirectForTermsAndConditions(): void {
    // !IMPORTANT do not merge conditions - we must check user separately
    const currentUser = this.user();
    if (currentUser && !currentUser.termsAndConditionsAccepted) {
      // If terms and conditions are not accepted, user will be redirected to CORE
      window.location.href = `${ENVIRONMENT.coreModule.locationUrl}`;
    }
  }

  onCloseNotifications(): void {
    this.#notificationsStore.toggleNotificationsSidenav();
  }

  onActivate(): void {
    const sidenavContent = this.matSidenavContent();

    if (sidenavContent?.getElementRef().nativeElement) {
      sidenavContent.getElementRef().nativeElement.scrollTop = 0;
    }
  }
}
